import React from 'react';
import { connect } from 'react-redux';
import Table from '../../../common/table/Table';
import CellHover from '../../../market/watchlist/summary/CellHover';
import RowClick from '../../../common/RowClick';
import { REDUCER_NAME, updateApiParams } from './reducer';
import { compose } from 'redux';
import { keyBy } from 'lodash';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import Const from './Const';
import TradingViewUrl from '../../../common/TradingViewUrl';
import { formatTextFloat, formatValueBillion } from '../../../helpers/Text';

class TableCanslim extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {};
    this.state = this.initialState;
    this.scrollRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { resetScrollIndex } = this.props;
    if (resetScrollIndex !== prevProps.resetScrollIndex) {
      this.scrollRef.current.scrollToTop();
    }
  }

  getDataFromRedux = () => {
    return state => state[REDUCER_NAME].listDataTableById;
  };

  getSchema = () => {
    const { title: tabTitle, schemaKey } = this.props;

    return Object.keys(schemaKey).map(item => {
      const key = schemaKey[item];
      const title = `${tabTitle}.${item}`;
      const result = {
        key,
        title,
      };

      if (key === Const.tableCanslim.TICKER) {
        return {
          ...result,
          isString: true,
          render: (text, item) => {
            return (
              <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
                <TradingViewUrl code={item.organCode} />
                &nbsp;
                {text}
              </CellHover>
            );
          },
        };
      }

      if (key === Const.tableCanslim.MARKET_CAP) {
        return {
          ...result,
          render: text => (
            <div className="text-right">
              {formatTextFloat(formatValueBillion(text))}
            </div>
          ),
        };
      }

      if (key === Const.tableCanslim.TOTAL) {
        return {
          ...result,
          thStyle: { textAlign: 'center' },
          render: text => <div className="text-center">{text}</div>,
        };
      }

      return {
        ...result,
        thStyle: { textAlign: 'center' },
        render: text => {
          const node =
            text === 1 ? (
              <i className="icon-correct" style={{ color: '#00de8b' }} />
            ) : (
              <div />
            );
          return <div className="d-flex justify-content-center">{node}</div>;
        },
      };
    });
  };

  handleScroll = e => {
    const { apiParams, totalPage, updateApiParams } = this.props;
    const { Page } = apiParams;
    if (Page === totalPage) return;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) <=
      e.target.clientHeight;
    if (bottom) {
      updateApiParams({ Page: Page + 1 });
    }
  };

  render() {
    const { canSlimData, isLoading, idHover, onSort } = this.props;
    let hoverCode = idHover;
    const listIds = canSlimData.map(item =>
      getDataFollowKeyByDot(item, 'organCode'),
    );

    const listFullData = keyBy(canSlimData, 'organCode');

    if (!listIds.includes(idHover) && idHover !== '') {
      hoverCode = '';
    }

    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            scrollRef={this.scrollRef}
            onScrollFunction={this.handleScroll}
            thValign="top"
            ids={listIds}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            getDataFromRedux={() => listFullData}
            schema={this.getSchema()}
            idHover={hoverCode}
            isLoading={isLoading}
            isHighlight={true}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    listDataTable: state[REDUCER_NAME].listDataTable,
    canSlimData: state[REDUCER_NAME].canSlimData,
    isLoading: state[REDUCER_NAME].isLoading,
    idHover: state[REDUCER_NAME].idHover,
    apiParams: state[REDUCER_NAME].apiParams,
    totalPage: state[REDUCER_NAME].totalPage,
  };
};

const mapDispatchToProps = {
  updateApiParams,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(TableCanslim);
